import { useParams } from 'react-router-dom';
import { ReactNode, useState, useEffect } from 'react'; // updated import
import Breadcrumb from '../../../common/breadcrumb/breadcrumb';
import { classNames } from '../../../../utils/classNamesUtils';
import { useTranslation } from 'react-i18next';
import React from 'react';

// TODO: store this in a config file
// const baseAssetUrl = 'https://operator-uploads.s3.us-east-2.amazonaws.com';

interface DeviceShellProps {
  // title: any;
  description?: ReactNode;
  dataTable?: ReactNode;
  charts?: ReactNode;
  dashboard?: ReactNode;
  alertTable?: ReactNode;
  defaultTab?: string;
}

const DeviceShell: React.FC<DeviceShellProps> = ({
  description,
  dataTable,
  charts,
  dashboard,
  alertTable,
  defaultTab,
}) => {
  const { t } = useTranslation();
  const { siteId, deviceId } = useParams();

  // Compute available tabs based on provided components.
  const computedTabs: any[] = [];
  if (dataTable) {
    computedTabs.push({ name: t('sites.data'), value: 'data' });
  }
  if (dashboard) {
    computedTabs.push({ name: t('sites.dashboard'), value: 'dashboard' });
  }
  if (charts) {
    computedTabs.push({ name: t('sites.charts'), value: 'charts' });
  }
  if (alertTable) {
    computedTabs.push({ name: t('sites.alerts'), value: 'alerts' });
  }

  const initialTab =
    defaultTab && computedTabs.find(tab => tab.value === defaultTab)
      ? defaultTab
      : computedTabs.length > 0
      ? computedTabs[0].value
      : 'data';

  const [currentTab, setCurrentTab] = useState(initialTab);

  useEffect(() => {
    if (defaultTab && computedTabs.find(tab => tab.value === defaultTab)) {
      setCurrentTab(defaultTab);
    }
  }, [defaultTab]);

  const handleTabChange = (value: string) => {
    setCurrentTab(value);
  };

  const breadcrumbPages = [
    { name: 'Site List', href: '/sites', current: false, isHome: true },
    { name: t('sites.siteDetail'), href: `/sites/${siteId}`, current: false },
    {
      name: t('sites.deviceDetail'),
      href: `/sites/${siteId}/devices/${deviceId}`,
      current: true,
    },
  ];

  return (
    <>
      <Breadcrumb pages={breadcrumbPages}></Breadcrumb>

      {description}

      <div className="mt-6">
        <div className="sm:hidden">
          <select
            id="tabs"
            name="tabs"
            value={currentTab}
            onChange={(e) => setCurrentTab(e.target.value)}
            className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          >
            {computedTabs.map((tab) => (
              <option key={tab.value} value={tab.value}>{tab.name}</option>
            ))}
          </select>
        </div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav aria-label="Tabs" className="-mb-px flex space-x-8">
              {computedTabs.map((tab) => (
                <span
                  onClick={() => handleTabChange(tab.value)}
                  key={tab.value}
                  aria-current={currentTab === tab.value ? 'page' : undefined}
                  className={classNames(
                    currentTab === tab.value
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700',
                    'flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium cursor-pointer'
                  )}
                >
                  {tab.name}
                </span>
              ))}
            </nav>
          </div>
        </div>
      </div>

      {currentTab === 'data' && dataTable}
      {currentTab === 'dashboard' && dashboard}
      {currentTab === 'charts' && charts}
      {currentTab === 'alerts' && alertTable}
    </>
  );
};

export default DeviceShell;
